/*
 * 2016 sitegeist media solutions GmbH
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of sitegeist media solutions GmbH and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to sitegeist media solutions GmbH
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from sitegeist media solutions GmbH.
 *
 */

/** @jsx h */

import {h, render, Component} from 'preact';
import mergeClassnames from 'classnames';

const STATE_IS_OPENING = 1;
const STATE_IS_OPEN = 2;
const STATE_IS_CLOSING = 3;
const STATE_IS_CLOSED = 4;

export default class Lightbox extends Component {
	state = {
		animation: STATE_IS_CLOSED
	};

	open() {
		const {animationDelay, onOpen} = this.props;

		this.setState({animation: STATE_IS_OPENING});
		this.setState({animation: STATE_IS_OPEN});

		setTimeout(() => {
			onOpen && onOpen();
		}, animationDelay | 500);
	}

	close() {
		const {animationDelay, onClose} = this.props;

		this.setState({animation: STATE_IS_CLOSING});

		setTimeout(() => {
			this.setState({animation: STATE_IS_CLOSED});
			onClose && onClose();
		}, animationDelay | 500);
	}

	componentDidMount() {
		const {opener, content, children} = this.props;

		opener && opener.forEach(o => o.addEventListener('click', () => this.open()));

		if (!children) {
			this.content = content.cloneNode(true);
			this.setState(this.state);
		}
	}

	render() {
		const {children} = this.props;
		const {animation} = this.state;
		const overlayClassNames = mergeClassnames({
			'lightbox__overlay': true,
			'lightbox__overlay--isOpening': animation === STATE_IS_OPENING,
			'lightbox__overlay--isOpen': animation === STATE_IS_OPEN,
			'lightbox__overlay--isClosing': animation === STATE_IS_CLOSING,
			'lightbox__overlay--isClosed': animation === STATE_IS_CLOSED,
		});
		const lightboxClassNames = mergeClassnames({
			'lightbox': true,
			'lightbox--isOpening': animation === STATE_IS_OPENING,
			'lightbox--isOpen': animation === STATE_IS_OPEN,
			'lightbox--isClosing': animation === STATE_IS_CLOSING,
			'lightbox--isClosed': animation === STATE_IS_CLOSED
		});
		const lightboxCloseBtnClassNames = 'lightbox__closeBtn toggleButton';
		const lightboxContentClassNames = 'lightbox__content';

		return (<div>
			<div className={overlayClassNames} onClick={() => this.close()}>
			</div>

			<div className={lightboxClassNames}>
				<button className={lightboxCloseBtnClassNames} onClick={() => this.close()}>
					<span className="buttonLine buttonLine--top buttonLine--top--click"></span>
					<span className="buttonLine buttonLine--middle buttonLine--middle--click"></span>
					<span className="buttonLine buttonLine--bottom buttonLine--bottom--click"></span>
	            </button>
				
				<div className={lightboxContentClassNames}>
					{children}
				</div>
			</div>
		</div>);
	}
}
